import React, { useState, useEffect } from "react";
import { Switch } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import logo from './logo_rnr.svg';
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";

import MyFooter from './containers/MyFooter';
import Login from './containers/Login';
import Home from './containers/Home';
import About from './containers/About';
import Glossary from './containers/Glossary';
import RiskDriver from './containers/RiskDriver';
import Quest from './containers/Quest';
import Estimation from './containers/Estimation';
import Projection from './containers/Projection';
import Pricing from './containers/Pricing';
import Upload from './containers/Upload';
import View from './containers/View';
import getData from './containers/TestAPI';
import NotFound from "./containers/NotFound";
import { onError } from "./libs/errorLib";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import { AppContext } from "./libs/contextLib";
import { startCase } from 'lodash';

function App() {
  const history = useHistory();
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    onLoad();
  }, [isAuthenticated]);
  
  async function onLoad() {
    try {
      await Auth.currentSession();
      userHasAuthenticated(true);
      Auth.currentAuthenticatedUser().then((user) => {
        //console.log('username = ' + user);
        setUserName(startCase(user.username));
        //console.log('username from state= ' +  userName);
      });

    }
    catch(e) {
      if (e !== 'No current user') {
        //alert(e);
        onError(e);
      }
    }
  
    setIsAuthenticating(false);
  }
  
  async function handleLogout() {
    try {
      await Auth.signOut();
      userHasAuthenticated(false);
      //console.log(Auth.currentUserInfo());
      history.push("/login");
      //console.log('signed out alridi');
    } catch (error){
      console.error('error', error);
    }
  }

  return (
    <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated, userName }}>
      {!isAuthenticating && (
        <div className="App">
          {isAuthenticated ? (
            <Navbar bg="light" expand="lg">
              <LinkContainer to="/home">
                <Navbar.Brand>
                  <img
                    alt=""
                    src={logo}
                    width="35"
                    height="35"
                    className="d-inline-block align-top"
                  />{' '}
                  Mini-Meucci React App
                </Navbar.Brand>
              </LinkContainer>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto container-fluid" activeKey={window.location.pathname}>
              {/* <Nav className="mr-auto" activeKey={window.location.pathname}> */}
                  <LinkContainer to="/home">
                    <Nav.Link>Home</Nav.Link>
                  </LinkContainer>
                  <NavDropdown title="Step" id="basic-nav-dropdown">
                    <IndexLinkContainer to="/step/risk-driver">
                      <NavDropdown.Item>Risk Driver Identification</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/step/quest">
                      <NavDropdown.Item>Quest for Invariance</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/step/estimation">
                      <NavDropdown.Item>Estimation</NavDropdown.Item> 
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/step/projection">
                      <NavDropdown.Item>Projection</NavDropdown.Item>
                    </IndexLinkContainer>
                    {/* <NavDropdown.Divider /> */}
                    <IndexLinkContainer to="/step/pricing">
                      <NavDropdown.Item>Pricing</NavDropdown.Item>
                    </IndexLinkContainer>
                  </NavDropdown>
                  <NavDropdown title="Data" id="basic-nav-dropdown1">
                    <IndexLinkContainer to="/data/view">
                      <NavDropdown.Item>View</NavDropdown.Item>
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/data/upload">
                      <NavDropdown.Item>Upload</NavDropdown.Item> 
                    </IndexLinkContainer>
                    <IndexLinkContainer to="/data/delete" disabled>
                      <NavDropdown.Item>Delete</NavDropdown.Item>
                    </IndexLinkContainer>
                  </NavDropdown>
                  <LinkContainer to="/glossary">
                    <Nav.Link>Glossary</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to="/about">
                    <Nav.Link>About</Nav.Link>
                  </LinkContainer>
                  <Nav.Link className="ml-auto" onClick={handleLogout}>Logout {userName}</Nav.Link>    
                </Nav>
              </Navbar.Collapse>
            </Navbar> 
          ) : (
            <>
              <Navbar bg="light" expand="lg">
                <LinkContainer to="/login">
                  <Navbar.Brand>
                    <img
                      alt=""
                      src={logo}
                      width="35"
                      height="35"
                      className="d-inline-block align-top"
                    />{' '}
                    Mini-Meucci React App
                  </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mr-auto" activeKey={window.location.pathname}>
                    <LinkContainer to="/login">
                      <Nav.Link>Login</Nav.Link>
                    </LinkContainer>
                  </Nav>
                </Navbar.Collapse>
              </Navbar> 
            </>
          )}

          <Switch>
            <UnauthenticatedRoute exact path='/login' component={Login}/>
            <AuthenticatedRoute exact path='/' component={Home}/>
            <AuthenticatedRoute exact path='/home' component={Home}/>
            <AuthenticatedRoute exact path='/step/risk-driver' component={RiskDriver}/>
            <AuthenticatedRoute exact path='/step/quest' component={Quest}/>
            <AuthenticatedRoute exact path='/step/estimation' component={Estimation}/>
            <AuthenticatedRoute exact path='/step/projection' component={Projection}/>
            <AuthenticatedRoute exact path='/step/pricing' component={Pricing}/>
            <AuthenticatedRoute exact path='/about' component={About}/>
            <AuthenticatedRoute exact path='/glossary' component={Glossary}/>
            <AuthenticatedRoute exact path='/data/view' component={View}/>
            <AuthenticatedRoute exact path='/data/upload' component={Upload}/>
            {/* <AuthenticatedRoute exact path='/api/test' component={getData}/>
            Finally, catch all unmatched routes */}
            <AuthenticatedRoute>
              <NotFound />
            </AuthenticatedRoute>
          </Switch>
          <MyFooter />
        </div>
      )}
    </AppContext.Provider>
  )
}      

export default App;
